@import '../../shared';

#rass-data-pasnr {
  --sfc-form-elements-input-error-margin-block-start: 3px;
  --sfc-form-elements-margin: 0;
  white-space: nowrap;
}

#rass-data-pasnr .sfc-input--state-has-errors {
  margin-bottom: 0;
}

#rass-checkbox label {
  white-space: nowrap;
}

@media (min-width: 576px) {
  div.checkbox {
    padding-top: var(--sfc-padding-100);
  }
}
